import {Injectable} from '@angular/core';
import {LightBoxInterface} from '@shared/modules/content/interfaces/light-box.interface';
import {Observable, of} from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LightBoxService {
    lightBoxImages: LightBoxInterface[] = [];

    public counter = 0;

    fetchImages(): Observable<LightBoxInterface[]> {
        return of(this.lightBoxImages);
    }

    addLightBoxImage(element: HTMLImageElement, label: string | undefined): void {
        const imageElement: LightBoxInterface = {
            label: label ?? '',
            src: element.src,
            showImage: true,
            index: this.counter,
        };

        const exists = this.lightBoxImages.some(image => image.src === element.src);

        if (!exists) {
            this.lightBoxImages.push(imageElement);
            this.counter++;
        }
    }

    clearLightBoxImages(): void {
        this.lightBoxImages =[];
    }
}
